export const timeFilter = [{
        name: "Last 3 months",
        value: "3Months",
        text: "last 3 months",
    },
    {
        name: "All time",
        value: "all",
        text: "All time",
    },
];

export const alertHistoryTimeFilter = [{
        name: "Last day",
        value: 1,
    },
    {
        name: "Last week",
        value: 7,
    },
    {
        name: "Last month",
        value: 30,
    },
    {
        name: "Last 3 months",
        value: 90,
    },
];

export const repeats = [{
        name: "Daily",
        value: "daily",
    },
    {
        name: "Weekly",
        value: "weekly",
    },
    {
        name: "Monthly",
        value: "monthly",
    },
    // {
    //     name: "Yearly",
    //     value: "yearly",
    // },
];

export const accumullates = [{
        name: "6 Months",
        value: "6 Months",
    },
    {
        name: "1 Year",
        value: "1 Year",
    },
    {
        name: "2 Years",
        value: "2 Years",
    },
    {
        name: "2 Years",
        value: "2 Years",
    },
    {
        name: "3 Years",
        value: "3 Years",
    },
    {
        name: "4 Years",
        value: "4 Years",
    },
    {
        name: "5 Years",
        value: "5 Years",
    },
    {
        name: "6 Years",
        value: "6 Years",
    },
    {
        name: "7 Years",
        value: "7 Years",
    },
    {
        name: "8 Years",
        value: "8 Years",
    },
    {
        name: "9 Years",
        value: "9 Years",
    },
];

export const startings = [{
        name: "6 Months Ago",
        value: "6 Months Ago",
    },
    {
        name: "1 Year Ago",
        value: "1 Year Ago",
    },
    {
        name: "2 Years Ago",
        value: "2 Years Ago",
    },
    {
        name: "2 Years Ago",
        value: "2 Years Ago",
    },
    {
        name: "3 Years Ago",
        value: "3 Years Ago",
    },
    {
        name: "4 Years Ago",
        value: "4 Years Ago",
    },
    {
        name: "5 Years Ago",
        value: "5 Years Ago",
    },
    {
        name: "6 Years Ago",
        value: "6 Years Ago",
    },
    {
        name: "7 Years Ago",
        value: "7 Years Ago",
    },
    {
        name: "8 Years Ago",
        value: "8 Years Ago",
    },
    {
        name: "9 Years Ago",
        value: "9 Years Ago",
    },
];

export const compares = [{
        name: "Yes",
        value: "Yes",
    },
    {
        name: "No",
        value: "No",
    },
];

export const timeRanges = [{
        name: "Last 30 days",
        value: 30,
    },
    {
        name: "Last 60 days",
        value: 60,
    },
    {
        name: "Last 120 days",
        value: 120,
    },
];

export const portfolioTypeFilters = [{
        type: "chart",
        name: "Chart",
    },
    {
        type: "allocation",
        name: "Allocation",
    },
    {
        type: "statistic",
        name: "Statistic",
    },
];

export const portfolioChartTimeFilters = [{
        type: "24H",
        name: "24H",
    },
    {
        type: "7D",
        name: "7D",
    },
    {
        type: "30D",
        name: "30D",
    },
    {
        type: "90D",
        name: "90D",
    },
    {
        type: "all",
        name: "All",
    },
];

export const fearGreedFilters = [{
        name: "7 days",
        value: 7,
    },
    {
        name: "1 month",
        value: 30,
    },
    {
        name: "3 months",
        value: 90,
    },
    {
        name: "1 year",
        value: 365,
    },
    {
        name: "Max",
        value: 1000,
    },
];